import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { shadow, ThemedValues } from 'styles/themed'

export const FooterStyles = StyleSheet.create( {
	container: {
		...shadow({
			elevation: 1,
			color: '#000',
			opacity: 0.2,
			radius: 2,
			offsetWidth: 0,
			offsetHeight: 1,
		}),
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		width: '100%',
		paddingTop: 12,
		paddingBottom: 12,
		paddingHorizontal: 12,
		height: 'auto',
		backgroundColor: colorList.WHITE.primary,
		// alignItems: 'flex-start',
		// alignSelf: 'flex-start',
		borderTopColor: colorList.PRIMARY.lighter,
		borderTopWidth: 1.5,
	},
	
	containerExtended: {
		top: 75,
	},
	
	items: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'flex-start'
	},
	buttons: {
		alignItems: 'flex-end',
		flex: 1,
	},
	buttons_multi: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'flex-end'
	},
	buttons_no_items: {
		width: '100%',
		alignItems: 'center'
	},
	button: {
		margin: 0,
	},
	buttonFill: {
		flex: 1,
		width: '100%'
	},
	buttonContainer: {
		flex: 1,
	},
	
	itemContainer: {
		maxWidth: 55,
		width: 55,
		height: 40,
		borderRadius: ThemedValues.borderRadius,
		marginRight: 5,
	},
	textContainer: {
		position: 'absolute',
		left: 0,
		top: 10,
		height: 20,
		width: 20,
		padding: 0,
		borderRadius: 4,
		borderColor: colorList.GREY.dark,
		borderWidth: 1,
		backgroundColor: colorList.WHITE.primary,
		justifyContent: 'center',
		alignItems: 'center'
	},
	text: {
		fontSize: 11,
		fontWeight: '900',
		color: colorList.BLACK.primary,
		textAlign: 'center',
	},
	iconContainer: {
		position: 'absolute',
		right: 0,
		top: 0,
		bottom: 0,
		width: 40,
		height: 40,
		justifyContent: 'center',
		alignItems: 'center'
	},
	icon: {
		fontSize: 18,
		color: colorList.WHITE.primary
	}
});
